import { Circle } from '@phosphor-icons/react';
import { getTruckConfig } from '../lib/truckConfig';

export default function TruckDiagram({ positions, onPositionClick, truckType }) {
  const config = getTruckConfig(truckType);
  const getPosition = (posNumber) => positions.find(p => p.position_number === posNumber);

  const renderWheel = (posNumber) => {
    const pos = getPosition(posNumber);
    const isOccupied = pos?.tire_id !== null && pos?.tire_id !== undefined;

    return (
      <button
        key={posNumber}
        onClick={() => onPositionClick(pos)}
        className={`group relative w-12 h-16 sm:w-14 sm:h-20 border-2 rounded-lg transition-all flex flex-col items-center justify-center ${
          isOccupied
            ? 'bg-white border-red-600 hover:bg-red-600'
            : 'bg-white border-zinc-300 hover:border-zinc-900 border-dashed'
        }`}
        data-testid={`wheel-position-${posNumber}`}
      >
        <Circle
          size={20}
          weight={isOccupied ? 'fill' : 'regular'}
          className={isOccupied ? 'text-red-600 group-hover:text-white' : 'text-zinc-400 group-hover:text-zinc-900'}
        />
        <span className={`text-[10px] font-mono mt-1 ${isOccupied ? 'text-zinc-900 group-hover:text-white' : 'text-zinc-900'}`}>{posNumber}</span>
      </button>
    );
  };

  const renderAxle = (axle) => {
    if (axle.wheelCount === 2) {
      return (
        <div className="flex items-center justify-between w-full">
          {renderWheel(axle.positions[0])}
          <div className="flex-1 h-1 bg-zinc-200 mx-2 rounded-full" />
          {renderWheel(axle.positions[1])}
        </div>
      );
    }
    return (
      <div className="flex items-center justify-between w-full">
        <div className="flex gap-1">
          {renderWheel(axle.positions[0])}
          {renderWheel(axle.positions[1])}
        </div>
        <div className="flex-1 h-1 bg-zinc-200 mx-2 rounded-full" />
        <div className="flex gap-1">
          {renderWheel(axle.positions[2])}
          {renderWheel(axle.positions[3])}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col items-center w-full" data-testid="truck-diagram">
      <div className="w-full max-w-md">
        <div className="mb-2 text-center">
          <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">▲ DEPAN</p>
        </div>
        <div className="border border-zinc-200 bg-zinc-50 rounded-2xl p-4 sm:p-6 space-y-6">
          {config.axles.map((axle) => (
            <div key={axle.name}>
              <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-2 text-center">
                {axle.name}
              </p>
              {renderAxle(axle)}
            </div>
          ))}
        </div>
        <div className="mt-2 text-center">
          <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">BELAKANG ▼</p>
        </div>
        <div className="mt-6 flex items-center justify-center gap-6 text-xs font-mono uppercase tracking-wider">
          <div className="flex items-center gap-2">
            <Circle size={12} weight="fill" className="text-red-600" />
            <span className="text-zinc-600">TERPASANG</span>
          </div>
          <div className="flex items-center gap-2">
            <Circle size={12} weight="regular" className="text-zinc-400" />
            <span className="text-zinc-600">KOSONG</span>
          </div>
        </div>
      </div>
    </div>
  );
}
